import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LocaleSwitch from "../../common/LocaleSwitch";
import Logo from "../../common/Logo";
import store from "../../../store";
import { verifySfaAndCompleteLogin, resendSfa } from "../../../providers/users";
import NumberFormat from "react-number-format";
import Loader from "../../common/Loader";
import Wave from "../../common/Wave";
import {checkIfTermsAreNotAccepted, getProfileActionsShared} from "./AuthUtils";
import {setSfaFlow, setUserLoggedInStatus} from "../../../actions/userActions";

const Translate = require('react-redux-i18n').Translate;

const stateMap = (store) => {
    return {
        i18n: store.i18n,
        userReducer: store.userReducer
    };
};

class SfaForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            fourDigitCode: '',
            sessionBlocked: false,
            completingLogin: false,
            smsBlocked: false,
        };
        this.handleFormattedChange = this.handleFormattedChange.bind(this);
        this.validateSfaAndCompleteLogin = this.validateSfaAndCompleteLogin.bind(this);
        this.checkFourDigitCodeIsFilled = this.checkFourDigitCodeIsFilled.bind(this);
        this.handleSfaErrors = this.handleSfaErrors.bind(this);
        this.resendCode = this.resendCode.bind(this);
    }

    componentDidMount() {
        if (!this.props.userReducer?.inSfaFlow) {
            this.props.history.replace('/login');
        }
    }

    validateSfaAndCompleteLogin() {
        const code = this.state.fourDigitCode;
        store.dispatch(verifySfaAndCompleteLogin(code)).then(
            (response) => {
                const showTerms = checkIfTermsAreNotAccepted(response?.value?.data?.payload?.errorMessage);
                this.setState({
                    errorMessage: '',
                    completingLogin: true
                }, ()=> {
                    store.dispatch(setSfaFlow(false));
                    getProfileActionsShared(showTerms, {
                        setState: (s) => this.setState(s),
                        invalidateAllErrors: () => {},
                        props: this.props
                    });
                });


            },
            (error) => {
                this.handleSfaErrors(error);
            }
        );
    }

    resendCode() {
        store.dispatch(resendSfa()).then(
            () => {
                this.setState({
                    errorMessage: ''
                });
            },
            (error) => {
                this.handleSfaErrors(error);
            }
        );
    }

    handleFormattedChange(obj, ev) {
        this.setState({
            [ev.target.id]: obj.value
        });
    }

    checkFourDigitCodeIsFilled() {
        return this.state.fourDigitCode.length < 4;
    }

    handleSfaErrors(error) {
        console.log(error)
        if (error.response && error.response.data) {
            const data = error.response.data;
            const errMsg = data.errors?.length > 0 ? data.errors[0] : null;
            if (errMsg === 'INVALID_SFA_CODE') {
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.invalidSfa'
                });
            } else if (errMsg === 'SFA_CODE_NOT_FOUND') {
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.sfaNotFound'
                });
            } else if (errMsg === 'SFA_CODE_EXPIRED') {
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.sfaExpired'
                });
            } else if (errMsg === 'TOO_MANY_FAILED_SFA_ATTEMPTS') {
                // Backend has already cleared the session/token, clear frontend state and show error
                store.dispatch(setUserLoggedInStatus(false));

                // Show error message so user knows what happened and block the form
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.tooManyAttempts',
                    sessionBlocked: true
                }, ()=> {
                    store.dispatch(setSfaFlow(false));
                });
            } else if (errMsg === 'TOO_MANY_SMS_REQUESTS') {
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.tooManySmsRequests',
                    smsBlocked: true
                }, ()=> {
                    store.dispatch(setSfaFlow(false));
                });
            } else if (errMsg === 'SFA_NO_SESSION_FOUND' || errMsg === 'SFA_SESSION_EXPIRED') {
                // Session expired or not found, clear state and redirect to login
                store.dispatch(setUserLoggedInStatus(false));
                store.dispatch(setSfaFlow(false));

                // Redirect to login immediately
                this.props.history.push('/login');
            } else {
                this.setState({
                    errorMessage: 'pages.login.sfa.errors.anErrorOccured'
                });
            }
        }
    }

    render() {
        const validatingSfa = this.props.userReducer &&
            this.props.userReducer.verifySfaAndCompleteLogin &&
            this.props.userReducer.verifySfaAndCompleteLogin.fetching;
        const resendingSfaCode = this.props.userReducer &&
            this.props.userReducer.resendSfa &&
            this.props.userReducer.resendSfa.fetching;

        // Show loader during SFA validation OR during login completion (profile actions)
        const isLoading = validatingSfa || this.state.completingLogin;

        return (
            <div className="otp-form">
                <main>
                    <div className="otp-form__top">
                        <LocaleSwitch type={"login-area"}></LocaleSwitch>
                    </div>
                    <div className="otp-form__content">
                        <div className="otp-form__left">
                            <div className="otp-form__resend-area">
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    this.resendCode();
                                }}>
                                    <button type="submit" className={"otp-form__resend-button" + (resendingSfaCode ? " pending-resend" : "")}
                                            disabled={resendingSfaCode || this.state.sessionBlocked || this.state.smsBlocked || validatingSfa || isLoading}>
                                        {resendingSfaCode ?
                                            <Loader bouncing={false} color={'bahama-blue'} message=''
                                                    style={{marginTop: 0}} bounceClass='smaller-bounces'/> :
                                            <Translate value="pages.userDetails.resendButton"/>
                                        }
                                    </button>
                                    <p className="otp-form__few">
                                        <Translate value="pages.login.sfa.info"/>
                                    </p>
                                </form>
                            </div>
                        </div>
                        <div className="otp-form__login-with-forgot">
                            <div className="otp-form__login-box">
                                <Logo isMain={false} isHeader={false} imgClassName="login"/>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    this.validateSfaAndCompleteLogin();
                                }}>
                                    <div className='otp-form__digit'>
                                        <div className='otp-form__digit-title'>
                                            <Translate value="pages.userDetails.mobilePhone"/>
                                            <span className={"icon-icon-mob"}>
                                            </span>
                                        </div>
                                        <div className="otp-form__digit-column">
                                            <Translate value="pages.userDetails.fourDigitCode"/>
                                            <NumberFormat
                                                type="text"
                                                id="fourDigitCode"
                                                format="####"
                                                className="otp-form__code"
                                                value={this.state.fourDigitCode}
                                                placeholder=""
                                                decimalScale={0}
                                                disabled={this.state.sessionBlocked}
                                                onValueChange={this.handleFormattedChange}/>
                                        </div>
                                    </div>
                                    <div className="otp-form__wrong-creds">
                                        {this.state.errorMessage !== '' ?
                                            <div className="generic-error-msg">
                                                <span className="icon-icon-attention"/>
                                                <div>
                                                    <Translate value={this.state.errorMessage} dangerousHTML/>
                                                </div>
                                            </div> : null
                                        }
                                    </div>
                                    <div className="otp-form__button-area">
                                        {!this.state.sessionBlocked && !this.state.smsBlocked ? (
                                            <button type="submit" className={"otp-form__login-button" +
                                                (this.checkFourDigitCodeIsFilled() || isLoading ? '__gray btn-disabled' : '')}
                                                    disabled={this.checkFourDigitCodeIsFilled() || isLoading}>
                                                {/* NOTE: Submit button is ONLY disabled by empty code or loading, NOT by smsBlocked */}
                                                {isLoading ?
                                                    <Loader bouncing={false} color={'white'} message=''
                                                            style={{marginTop: 0}} bounceClass='smaller-bounces'/> :
                                                    <Translate value="pages.userDetails.submitButtonText"/>
                                                }
                                            </button>
                                        ) : (
                                            <button type="button"
                                                    className="otp-form__login-button"
                                                    onClick={() => this.props.history.push('/login')}>
                                                <Translate value="pages.login.sfa.backToLogin"/>
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Wave />
                </main>
            </div>
        );
    }
}

export default withRouter(connect(stateMap)(SfaForm));
